import React from "react";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
interface IDividerProps {}

const Divider: React.FC<IDividerProps> = (props) => {
  const {} = props;
  return (
    <div className={tw`relative`}>
      <div
        className={tw`absolute inset-0 flex items-center`}
        aria-hidden="true"
      >
        <div className={tw`w-full border-t border-gray-300`} />
      </div>
    </div>
  );
};

export default Divider;
